export interface MovieItem {
  id: string;
  title: string;
  category: 'movie' | 'tv' | 'variety' | 'anime';
  categoryLabel: string;
  imageSeq: string;
  rating: number;
  year: number;
  region: string;
  description: string;
  tags: string[];
  featured: boolean;
  updateDate: string;
}

export const categoryMap: Record<string, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
  anime: '动漫',
};

export const movies: MovieItem[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-01',
    rating: 8.5,
    year: 2026,
    region: '中国大陆',
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类在地球表面建造出巨大的推进器，寻找新的家园。面对宇宙旅途中的未知与危险，人类命运将何去何从？',
    tags: ['科幻', '冒险', '灾难'],
    featured: true,
    updateDate: '2026-08-05',
  },
  {
    id: 'movie-2',
    title: '长安三万里2',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-02',
    rating: 8.8,
    year: 2026,
    region: '中国大陆',
    description: '安史之乱后，大唐由盛转衰。诗人高适回忆起与李白数十年的友谊，以及那个诗歌与理想闪耀的时代。一段关于友情、理想与家国情怀的壮丽史诗。',
    tags: ['动画', '历史', '文学'],
    featured: true,
    updateDate: '2026-08-04',
  },
  {
    id: 'movie-3',
    title: '封神第二部',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-03',
    rating: 8.2,
    year: 2026,
    region: '中国大陆',
    description: '商王殷寿残暴无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主。姬发觉醒，率领八百诸侯反抗暴政，一场惊天动地的封神大战拉开帷幕。',
    tags: ['奇幻', '动作', '史诗'],
    featured: true,
    updateDate: '2026-08-03',
  },
  {
    id: 'movie-4',
    title: '志愿军：雄兵出击2',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-04',
    rating: 8.0,
    year: 2026,
    region: '中国大陆',
    description: '1950年朝鲜战争爆发，中国人民志愿军跨过鸭绿江，在极端恶劣的条件下与装备精良的敌军展开殊死搏斗，用血肉之躯捍卫了国家尊严。',
    tags: ['战争', '历史', '剧情'],
    featured: false,
    updateDate: '2026-08-02',
  },
  {
    id: 'movie-5',
    title: '深海2',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-05',
    rating: 8.3,
    year: 2026,
    region: '中国大陆',
    description: '一个沉溺于深海梦境的小女孩，在神秘的海底世界中展开了一段奇幻冒险。绚丽的粒子水墨画面，讲述了一个关于孤独、勇气与爱的动人故事。',
    tags: ['动画', '奇幻', '治愈'],
    featured: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'movie-6',
    title: '红海行动2',
    category: 'movie',
    categoryLabel: '电影',
    imageSeq: 'movie-cover-06',
    rating: 8.1,
    year: 2026,
    region: '中国大陆',
    description: '中国海军蛟龙突击队接到紧急任务，前往海外执行撤侨行动。在异国他乡，他们面对重重危险，以过硬的军事素养和无畏的牺牲精神完成使命。',
    tags: ['动作', '战争', '军事'],
    featured: false,
    updateDate: '2026-07-30',
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-01',
    rating: 9.1,
    year: 2026,
    region: '中国大陆',
    description: '范闲在经历生死考验后，决定与命运抗争到底。朝堂之上暗流涌动，江湖之中风波再起。范闲凭借智谋与勇气，逐步揭开隐藏在这个世界背后的惊天秘密。',
    tags: ['古装', '权谋', '喜剧'],
    featured: true,
    updateDate: '2026-08-06',
  },
  {
    id: 'tv-2',
    title: '狂飙',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-02',
    rating: 9.3,
    year: 2025,
    region: '中国大陆',
    description: '一部横跨二十年的扫黑除恶史诗。刑警安欣与黑恶势力展开长达二十年的较量，展现了扫黑除恶斗争中一线干警的坚守与奉献。',
    tags: ['犯罪', '悬疑', '剧情'],
    featured: true,
    updateDate: '2026-08-05',
  },
  {
    id: 'tv-3',
    title: '三体',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-03',
    rating: 8.7,
    year: 2025,
    region: '中国大陆',
    description: '纳米科学家汪淼被卷入一场神秘事件，发现了地球基础科学被锁死的真相。随着调查深入，一个来自三体文明的外星威胁逐渐浮出水面。',
    tags: ['科幻', '悬疑', '剧情'],
    featured: false,
    updateDate: '2026-08-04',
  },
  {
    id: 'tv-4',
    title: '繁花',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-04',
    rating: 8.9,
    year: 2025,
    region: '中国大陆',
    description: '九十年代的上海，改革开放的春风中，阿宝凭借自己的智慧与胆识在商海中沉浮。一段关于梦想、爱情与时代的上海传奇故事。',
    tags: ['都市', '爱情', '年代'],
    featured: false,
    updateDate: '2026-08-01',
  },
  {
    id: 'tv-5',
    title: '漫长的季节',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-05',
    rating: 9.4,
    year: 2025,
    region: '中国大陆',
    description: '一座东北小城，一桩跨越二十年的悬案。出租车司机王响在追查儿子死亡真相的过程中，揭开了一段尘封已久的往事，也重新审视了自己的人生。',
    tags: ['悬疑', '剧情', '生活'],
    featured: false,
    updateDate: '2026-07-28',
  },
  {
    id: 'tv-6',
    title: '长相思第二季',
    category: 'tv',
    categoryLabel: '电视剧',
    imageSeq: 'tv-cover-06',
    rating: 8.6,
    year: 2026,
    region: '中国大陆',
    description: '上古时期，人神共存。小夭身世之谜逐渐揭开，在涂山璟、相柳和玱玹三人的情感纠葛中，她必须做出最艰难的选择。一段跨越千年的爱恨情仇。',
    tags: ['古装', '爱情', '奇幻'],
    featured: false,
    updateDate: '2026-07-25',
  },
  {
    id: 'variety-1',
    title: '奔跑吧第十季',
    category: 'variety',
    categoryLabel: '综艺',
    imageSeq: 'variety-cover-01',
    rating: 8.0,
    year: 2026,
    region: '中国大陆',
    description: '王牌综艺强势回归！新老成员齐聚一堂，在全新的游戏挑战中展现默契与欢笑。每一期都有意想不到的嘉宾和惊喜，让你笑到停不下来。',
    tags: ['真人秀', '竞技', '搞笑'],
    featured: true,
    updateDate: '2026-08-06',
  },
  {
    id: 'variety-2',
    title: '向往的生活第八季',
    category: 'variety',
    categoryLabel: '综艺',
    imageSeq: 'variety-cover-02',
    rating: 8.3,
    year: 2026,
    region: '中国大陆',
    description: '远离城市喧嚣，回归田园生活。黄磊、何炅带领新老朋友们在蘑菇屋中自给自足，用美食与欢笑温暖每一个平凡的日子。',
    tags: ['真人秀', '美食', '生活'],
    featured: false,
    updateDate: '2026-08-05',
  },
  {
    id: 'variety-3',
    title: '歌手2026',
    category: 'variety',
    categoryLabel: '综艺',
    imageSeq: 'variety-cover-03',
    rating: 8.1,
    year: 2026,
    region: '中国大陆',
    description: '华语乐坛顶级歌手齐聚舞台，用音乐对话，用歌声竞技。每一期都带来震撼人心的音乐盛宴，见证实力唱将的巅峰对决。',
    tags: ['音乐', '竞技', '真人秀'],
    featured: false,
    updateDate: '2026-08-04',
  },
  {
    id: 'anime-1',
    title: '凡人修仙传 星海飞驰篇',
    category: 'anime',
    categoryLabel: '动漫',
    imageSeq: 'anime-cover-01',
    rating: 9.0,
    year: 2026,
    region: '中国大陆',
    description: '韩立踏入星海，在更加广阔的修仙世界中继续他的旅程。面对强大的对手和未知的危险，他凭借坚韧不拔的意志和过人的智慧不断突破自我。',
    tags: ['修仙', '奇幻', '动作'],
    featured: true,
    updateDate: '2026-08-06',
  },
  {
    id: 'anime-2',
    title: '斗破苍穹 年番',
    category: 'anime',
    categoryLabel: '动漫',
    imageSeq: 'anime-cover-02',
    rating: 8.8,
    year: 2026,
    region: '中国大陆',
    description: '萧炎在斗气大陆上的冒险仍在继续。从乌坦城走出的少年，一步步成长为真正的强者。异火、丹药、战斗，一个宏大的玄幻世界徐徐展开。',
    tags: ['玄幻', '动作', '冒险'],
    featured: false,
    updateDate: '2026-08-05',
  },
  {
    id: 'anime-3',
    title: '完美世界',
    category: 'anime',
    categoryLabel: '动漫',
    imageSeq: 'anime-cover-03',
    rating: 8.7,
    year: 2026,
    region: '中国大陆',
    description: '一粒尘可填海，一根草斩尽日月星辰。石昊在大荒中崛起，以无敌之姿横扫诸天万界。热血沸腾的战斗场面，宏大深邃的世界观设定。',
    tags: ['玄幻', '热血', '战斗'],
    featured: false,
    updateDate: '2026-08-03',
  },
  {
    id: 'anime-4',
    title: '仙逆',
    category: 'anime',
    categoryLabel: '动漫',
    imageSeq: 'anime-cover-04',
    rating: 8.6,
    year: 2026,
    region: '中国大陆',
    description: '顺为凡，逆则仙。王林以平凡之躯踏上修仙之路，在残酷的修真世界中以逆天之心闯出一条属于自己的道。',
    tags: ['修仙', '奇幻', '热血'],
    featured: false,
    updateDate: '2026-08-02',
  },
];

export const getMoviesByCategory = (category: string): MovieItem[] => {
  return movies.filter((m) => m.category === category);
};

export const getFeaturedMovies = (): MovieItem[] => {
  return movies.filter((m) => m.featured);
};

export const getMovieById = (id: string): MovieItem | undefined => {
  return movies.find((m) => m.id === id);
};

export const categories = [
  { slug: 'movie', label: '电影', icon: 'ri-movie-2-line' },
  { slug: 'tv', label: '电视剧', icon: 'ri-tv-2-line' },
  { slug: 'variety', label: '综艺', icon: 'ri-live-line' },
  { slug: 'anime', label: '动漫', icon: 'ri-rocket-2-line' },
];